export const FAILED_AGE_CHECK_REQUIRED = 'FAILED_AGE_CHECK_REQUIRED';
